import { render, staticRenderFns } from "./app-update-password.vue?vue&type=template&id=1f0afe04&"
import script from "./app-update-password.vue?vue&type=script&lang=ts&"
export * from "./app-update-password.vue?vue&type=script&lang=ts&"
import style0 from "./app-update-password.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports